import script from "./PricingBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingBlock.vue?vue&type=script&setup=true&lang=js"

import "./PricingBlock.vue?vue&type=style&index=0&id=2a92405c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a92405c"]])

export default __exports__